module.exports = __webpack_public_path__ + "img/GHS-pictogram-skull.5c409359.png";